import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a1256b76")

_pushScopeId("data-v-a1256b76")
const _hoisted_1 = { class: "dialog-overlay" }
const _hoisted_2 = { class: "dialog-display-area" }
const _hoisted_3 = { class: "dialog-box" }
const _hoisted_4 = { class: "dialog-box-title" }
const _hoisted_5 = { class: "dialog-box-title-text" }
const _hoisted_6 = {
  key: 0,
  class: "dialog-box-contents"
}
const _hoisted_7 = {
  id: "dialog-box-contents-iframe-id",
  class: "dialog-box-contents-iframe",
  src: "about:blank",
  ref: "scrollIframe"
}
const _hoisted_8 = {
  key: 1,
  class: "dialog-box-contents"
}
const _hoisted_9 = {
  class: "dialog-box-contents-image",
  ref: "scroll"
}
const _hoisted_10 = { class: "dialog-box-bottom" }
const _hoisted_11 = { class: "dialog-box-bottom-closebutton-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_Transition, { name: "dialog" }, {
      default: _withId(() => [
        _withDirectives(_createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("span", _hoisted_5, _toDisplayString(_ctx.displayTitle), 1)
              ]),
              (_ctx.isUseContents)
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    _createVNode("iframe", _hoisted_7, "\n              ", 512)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode("img", {
                        class: "dialog-box-contents-image-image",
                        src: _ctx.contentsImage
                      }, null, 8, ["src"])
                    ], 512)
                  ])),
              _createVNode("div", _hoisted_10, [
                _createVNode("div", {
                  class: "dialog-box-bottom-closebutton",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeClicked(...args)))
                }, [
                  _createVNode("div", _hoisted_11, _toDisplayString(_ctx.closeText), 1)
                ])
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.isShowDialog]
        ])
      ]),
      _: 1
    })
  ]))
})